import { operandiRetryRevision } from './operandiRetrySession';
const STORAGE_KEY = 'operandi-human-context-pending-v1';

function tabStorage() {
  if (typeof window === 'undefined') return null;
  try { return window.sessionStorage; } catch { return null; }
}

export async function tokenFingerprint(token) {
  if (!window.crypto?.subtle || typeof token !== 'string' || !token) return null;
  const encoded = encodeURIComponent(token).replace(/%([0-9A-F]{2})|./gi,
    (match, hex) => String.fromCharCode(hex ? parseInt(hex, 16) : match.charCodeAt(0)));
  const bytes = Uint8Array.from(encoded, character => character.charCodeAt(0));
  try {
    const digest = await window.crypto.subtle.digest('SHA-256', bytes);
    return [...new Uint8Array(digest)].map(byte => byte.toString(16).padStart(2, '0')).join('');
  } catch { return null; }
}

export async function persistPendingCapture(capture, scope) {
  const revision = operandiRetryRevision();
  const storage = tabStorage();
  const fingerprint = await tokenFingerprint(scope.token);
  if (!storage || !fingerprint || revision !== operandiRetryRevision()) return false;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({
      version: 1,
      organization_id: scope.orgId,
      location_id: scope.locationId,
      token_fingerprint: fingerprint,
      capture,
    }));
    return true;
  } catch { return false; }
}

export async function loadPendingCapture(scope) {
  const revision = operandiRetryRevision();
  const storage = tabStorage();
  if (!storage) return null;
  let raw;
  try { raw = storage.getItem(STORAGE_KEY); } catch { return null; }
  if (!raw) return null;
  try {
    const saved = JSON.parse(raw);
    const fingerprint = await tokenFingerprint(scope.token);
    if (revision !== operandiRetryRevision() || storage.getItem(STORAGE_KEY) !== raw) return null;
    const capture = saved?.capture;
    const sameScope = saved?.version === 1 && saved.organization_id === scope.orgId &&
      saved.location_id === scope.locationId && fingerprint && saved.token_fingerprint === fingerprint;
    const validCapture = capture && typeof capture === 'object' &&
      typeof capture.command_id === 'string' && typeof capture.run_id === 'string' &&
      typeof capture.statement === 'string' && Array.isArray(capture.evidence_refs);
    if (sameScope && validCapture) return capture;
  } catch { /* Invalid tab-local data is discarded below. */ }
  try {
    if (storage.getItem(STORAGE_KEY) === raw) storage.removeItem(STORAGE_KEY);
  } catch { /* Storage can be disabled by browser policy. */ }
  return null;
}

export function clearPendingCapture() {
  try { tabStorage()?.removeItem(STORAGE_KEY); } catch { /* Storage can be disabled by browser policy. */ }
}
